module.exports = __webpack_public_path__ + "assets/web-icon.a03add31.svg";